import { observer } from 'mobx-react-lite';
import Box from '@mui/material/Box';
import styled from '@mui/system/styled';
import { useStore } from '@/stores';
import AccountButton from './AccountButton';

const Root = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	gap: 8,
	padding: '8px 0',
}));

type VM = 'evm' | 'solana' | 'sui';

const VM_LABELS: Record<VM, string> = {
	evm: 'EVM Wallet',
	solana: 'Solana Wallet',
	sui: 'SUI Wallet',
};

type WalletSubHeaderProps = {
	/** Which VM wallet buttons to show */
	vms: VM[];
};

const WalletSubHeader = observer(function WalletSubHeader({ vms }: WalletSubHeaderProps) {
	const store = useStore();

	const getWalletForVM = (vm: VM) => {
		switch (vm) {
			case 'evm':
				return store.wallets.connectedWallets.find((w) => w.type === 'evm');
			case 'solana':
				return store.wallets.connectedWallets.find((w) => w.type === 'solana');
			case 'sui':
				return store.wallets.connectedWallets.find((w) => w.type === 'sui');
		}
	};

	const handleConnect = (vm: VM) => {
		const chains = store.configs.combinedChains;
		let chain: Chain | undefined;
		switch (vm) {
			case 'evm':
				chain = chains.find((c) => c.mode === 'EVM');
				break;
			case 'solana':
				chain = chains.find((c) => c.mode === 'SOLANA');
				break;
			case 'sui':
				chain = chains.find((c) => c.mode === 'SUI');
				break;
		}
		if (chain) {
			store.chains.setOriginChain(chain);
			store.modal.open('origin');
		}
	};

	return (
		<Root>
			{vms.map((vm) => (
				<AccountButton
					key={vm}
					vmType={vm}
					label={VM_LABELS[vm]}
					wallet={getWalletForVM(vm)}
					onConnect={() => handleConnect(vm)}
				/>
			))}
		</Root>
	);
});

export default WalletSubHeader;
